import UnknownProgressBar from "components/progressbar/UnknownProgressBar.js";
import React, { useEffect, useCallback, useState} from 'react';
import {AbstractParameter} from "parameters/AbstractParameter.js";
import ZoraMintConfiguration from './ZoraMintConfiguration.js';
import ZoraRenderer from "components/nft/ZoraRenderer.js";
import {getMetadata, mintToZora} from 'nft/zora.js';
import {
    setNewZoraTokenId,
    setMintingProgress,
    setZoraDialog} from 'actions/index.js';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import { Button } from 'reactstrap';
import {
  MediaRendererProps,
  MediaObject,
  MediaConfiguration,
} from "@zoralabs/nft-components";

const ZoraDialog = ({
    setZoraDialog,
    data,
    sequencerEngine,
    setMintingProgress,
    mintingProgress,
    newZoraTokenId,
    setNewZoraTokenId
}) => { 
    let [metadata, setMetadata] = useState(undefined);
    let [royalties, setRoyalties] = useState(undefined);
    let [description, setDescription] = useState('');
    let [thumbnail, setThumbnail] = useState(data && data.screenshots[0]);
    let [alternateThumbnails, setAlternateThumbnails] = useState(data && data.screenshots);
    let [name, setName] = useState('');
    let [error, setError] = useState(false);

    useEffect(() => {
         let royalties = new AbstractParameter(
            "royalties",
            {},
             (x) => 0,
            {
                defaultValue: 10,
                min: 0,
                max: 100,
            });
        royalties.setStore(sequencerEngine.store);
        setRoyalties(royalties);
    }, []);

    let url = "https://zequencer.io/ipfs/" + data.page + '/';
    console.log("url = ", url);

    const mint = useCallback(() => {
        setMintingProgress("Verifying your NFT");
        mintToZora(data, name, description, thumbnail, royalties.get(), sequencerEngine)
            .then(
                x => setMintingProgress(undefined))
            .catch(
                e => {
                    if (e === "timed out") {
                        // retry one more time
                        mintToZora(data, name, description, thumbnail, royalties.get(), sequencerEngine)
                            .then(
                                x => setMintingProgress(undefined))
                            .catch(
                                x => {
                                    setError(true);
                                    setMintingProgress(undefined);
                                });
                    } else {
                        setMintingProgress(undefined);
                    }
                });
                        
    }, [data, royalties, thumbnail, name, description]);

    useEffect(() => {
        getMetadata(data).then(
            setMetadata);
    }, [data, setMetadata]);

    if (!mintingProgress  && newZoraTokenId) {
        return (
            <Modal dialogClassName="zora-modal preset-modal mint-completed" show={true} onHide={() => setZoraDialog(undefined)}>
              <Modal.Body>
                <div className="completed-minting-message">
                  Congratulations, you've minted a new NFT on Zora.
                </div>
                <div className="mint-links">
                  Go to your <a href="/collect">collection page</a> to see your all your minted works.
                </div>
                <div className="mint-links">
                  You can also check it out on Zora, <a href={`https://zora.co/collections/zora/${newZoraTokenId}`}>here</a>.
                </div>
              </Modal.Body>
            </Modal>);
    }

    return (
        <Modal
          dialogClassName="zora-modal preset-modal"
          show={true}
          onHide={() => {
              setMintingProgress(undefined);
              setZoraDialog(undefined);
              setNewZoraTokenId(undefined);
          }}
        >
          <Modal.Body>
            {mintingProgress &&
             <UnknownProgressBar
               intervalPiece={1}
               text={mintingProgress}
               width={900}
               intervalTime={100}/>}
            {metadata &&
             <ZoraRenderer
               metadata={metadata}
               contentURI={url}
             />}
            <ZoraMintConfiguration
              name={name}
              description={description}
              royalties={royalties}
              thumbnail={thumbnail}
              alternateThumbnails={alternateThumbnails}
              setName={setName}
              setDescription={setDescription}
              setThumbnail={setThumbnail}
              />
         </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={mint}>
              Mint on Zora
            </Button>
          </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
      mintingProgress: state.nft.mintingProgress,
      newZoraTokenId: state.nft.newZoraTokenId
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setNewZoraTokenId: x => dispatch(setNewZoraTokenId(x)),
      setZoraDialog: x => dispatch(setZoraDialog(x)),
      setMintingProgress: x => dispatch(setMintingProgress(x))
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(ZoraDialog);
